import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  createOrder,
  getCreateOrdersByPage,
} from '../../ApiServices/CreateOrderServices';
import { RootState } from '../reduxStore';
import { hideLoader, showLoader } from './loaderSlice';
import { showErrorSnackbar, showSuccessSnackbar } from './snackbarSlice';
import { getProductsByPage } from '../../ApiServices/ProductsService';
import { t } from 'i18next';

export const initialStatee = {
  value: { totalCount: -1, data: [{}], categories: [''], subCategories: [''] },
  loading: false,
  error: null,
  rowsPerPage: 10,
  pageNo: 0,
  selectedValue: null,
  filter: {},
};

const createordersSlice = createSlice({
  name: 'createorder',
  initialState: initialStatee,
  reducers: {
    clearCreateOrdersState(state: any) {
      state.rowsPerPage = initialStatee.rowsPerPage;
      state.pageNo = initialStatee.pageNo;
      state.value = initialStatee.value;
      state.loading = false;
      state.error = null;
      state.selectedValue = initialStatee.selectedValue;
      state.filter = initialStatee.filter;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchcreateOrders.fulfilled, (state: any, action: any) => {
      state.error = initialStatee.error;
      state.loading = initialStatee.loading;
      state.selectedValue = initialStatee.selectedValue;
      state.value = action?.payload?.data;
      state.pageNo = action?.meta?.arg?.page;
      state.filter = action?.meta?.arg;
    });
    builder.addCase(fetchcreateOrders.rejected, (state: any, action: any) => {
      state.error = initialStatee.error;
      state.loading = initialStatee.loading;
      state.selectedValue = initialStatee.selectedValue;
      state.filter = action?.meta?.arg;
    });
  },
});

export const createOrderState = (state: RootState) => state?.createorder;
export const { clearCreateOrdersState } = createordersSlice.actions;
export default createordersSlice.reducer;

export const fetchcreateOrders = createAsyncThunk(
  'createorder/fetchcreateOrders',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('FETCHING_CREATE_ORDERS') }));
      return fulfillWithValue(await getCreateOrdersByPage(payload));
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const createorders = createAsyncThunk(
  'createorder/createorders',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      const response: any = await createOrder(payload);
      if (response?.status === 200 || response === 200) {
        dispatch(showSuccessSnackbar({ message: t('ORDER_CREATED_SUCCESS') }));
        return fulfillWithValue(response);
      } else {
        dispatch(showErrorSnackbar({ message: t('ORDER_CREATION_FAILED') }));
        return rejectWithValue(response);
      }
      // dispatch(showSuccessSnackbar({ message: response?.data?.message }));
      // return fulfillWithValue(response);
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const downloadOrderProducts = createAsyncThunk(
  'createorder/downloadOrderProducts',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('DOWNLOADING_PRODUCTS') }));
      let response: any = await getProductsByPage(payload);
      if (response === 200)
        dispatch(showSuccessSnackbar({ message: t('DOWNLOAD_SUCCESS') }));
      else dispatch(showErrorSnackbar({ message: t('DOWNLOAD_FAILS') }));
      return fulfillWithValue(response);
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);
